module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"volume":"Volume","grossWeight":"Gross Weight","licencePlate":"Licence Plate"},"no":{"volume":"Volum","grossWeight":"Brutto vekt","licencePlate":"Kollinummer"}}')
  delete Component.options._Ctor
}
